import React, { useState, useEffect } from 'react';

const TrainingCertificate = ({ certificateId, onClose }) => {
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCertificate();
  }, [certificateId]);

  const fetchCertificate = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(
        `https://app.salonlogic.co.uk/api/documents/training/certificate/${certificateId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (!response.ok) throw new Error('Failed to fetch certificate');

      const data = await response.json();
      setCertificate(data.certificate);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '32px',
          borderRadius: '12px',
          textAlign: 'center',
        }}>
          <div style={{
            width: '32px',
            height: '32px',
            border: '4px solid #e2e8f0',
            borderTopColor: '#3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto',
          }}></div>
          <p style={{ marginTop: '16px', color: '#64748b' }}>Loading certificate...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '32px',
          borderRadius: '12px',
          maxWidth: '400px',
        }}>
          <p style={{ color: '#dc2626', marginBottom: '16px' }}>{error}</p>
          <button
            onClick={onClose}
            style={{
              padding: '10px 24px',
              backgroundColor: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '16px',
    }}>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @media print {
          body * {
            visibility: hidden;
          }
          .certificate-content,
          .certificate-content * {
            visibility: visible;
          }
          .certificate-content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            padding: 0.5in;
          }
          .print-hidden {
            display: none !important;
          }
        }
      `}</style>

      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
      }}>
        {/* Action Bar */}
        <div className="print-hidden" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px',
          borderBottom: '1px solid #e5e7eb',
        }}>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#1f2937',
            margin: 0,
          }}>
            Training Certificate
          </h2>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={handlePrint}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 20px',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              🖨️ Print
            </button>
            <button
              onClick={handlePrint}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '10px 20px',
                backgroundColor: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              💾 Download
            </button>
            <button
              onClick={onClose}
              style={{
                padding: '10px',
                color: '#6b7280',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '20px',
              }}
            >
              ✕
            </button>
          </div>
        </div>

        {/* Certificate Content */}
        <div className="certificate-content" style={{ padding: '48px', backgroundColor: 'white' }}>
          <div style={{
            border: '8px double #1e3a8a',
            padding: '32px',
            position: 'relative',
          }}>
            {/* Corner Decorations */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '64px',
              height: '64px',
              borderTop: '4px solid #d4af37',
              borderLeft: '4px solid #d4af37',
            }}></div>
            <div style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '64px',
              height: '64px',
              borderTop: '4px solid #d4af37',
              borderRight: '4px solid #d4af37',
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '64px',
              height: '64px',
              borderBottom: '4px solid #d4af37',
              borderLeft: '4px solid #d4af37',
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              width: '64px',
              height: '64px',
              borderBottom: '4px solid #d4af37',
              borderRight: '4px solid #d4af37',
            }}></div>

            <div style={{ textAlign: 'center' }}>
              {/* Award Icon */}
              <div style={{ marginBottom: '24px' }}>
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '96px',
                  height: '96px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #fbbf24 0%, #d97706 100%)',
                }}>
                  <span style={{ fontSize: '48px' }}>🏆</span>
                </div>
              </div>

              {/* Title */}
              <h1 style={{
                fontSize: '48px',
                fontFamily: 'Georgia, serif',
                fontWeight: 'bold',
                color: '#1f2937',
                margin: '0 0 8px 0',
              }}>
                Certificate of Completion
              </h1>
              <div style={{
                width: '128px',
                height: '4px',
                background: 'linear-gradient(to right, #3b82f6, #8b5cf6)',
                margin: '0 auto 32px auto',
              }}></div>

              {/* This certifies that */}
              <p style={{
                fontSize: '18px',
                color: '#4b5563',
                fontStyle: 'italic',
                margin: '32px 0 16px 0',
              }}>
                This is to certify that
              </p>

              {/* Employee Name */}
              <h2 style={{
                fontSize: '36px',
                fontFamily: 'Georgia, serif',
                fontWeight: 'bold',
                color: '#1e40af',
                borderBottom: '2px solid #d1d5db',
                display: 'inline-block',
                padding: '0 48px 8px 48px',
                margin: '0 0 24px 0',
              }}>
                {certificate?.employee_name}
              </h2>

              {/* Has successfully completed */}
              <p style={{
                fontSize: '18px',
                color: '#4b5563',
                margin: '24px 0 16px 0',
              }}>
                has successfully completed the training module
              </p>

              {/* Module Title */}
              <h3 style={{
                fontSize: '28px',
                fontWeight: '600',
                color: '#1f2937',
                margin: '16px 0',
              }}>
                {certificate?.module_title}
              </h3>

              {/* Module Description */}
              {certificate?.module_description && (
                <p style={{
                  fontSize: '14px',
                  color: '#6b7280',
                  maxWidth: '600px',
                  margin: '8px auto',
                  lineHeight: '1.6',
                }}>
                  {certificate.module_description}
                </p>
              )}

              {/* Score */}
              <div style={{
                marginTop: '32px',
                background: 'linear-gradient(135deg, #ecfdf5 0%, #dbeafe 100%)',
                padding: '16px',
                borderRadius: '12px',
                display: 'inline-block',
              }}>
                <p style={{
                  fontSize: '28px',
                  fontWeight: 'bold',
                  color: '#047857',
                  margin: 0,
                }}>
                  Score: {certificate?.score}%
                </p>
              </div>

              {/* Bottom Section - Date and Signature */}
              <div style={{
                marginTop: '48px',
                paddingTop: '32px',
                borderTop: '2px solid #e5e7eb',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                padding: '32px 48px 0 48px',
              }}>
                {/* Date */}
                <div style={{ textAlign: 'left' }}>
                  <div style={{
                    borderBottom: '2px solid #9ca3af',
                    paddingBottom: '4px',
                    marginBottom: '8px',
                    width: '192px',
                  }}>
                    <p style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#1f2937',
                      margin: 0,
                    }}>
                      {certificate?.issued_at_formatted}
                    </p>
                  </div>
                  <p style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    margin: 0,
                  }}>
                    Date of Completion
                  </p>
                </div>

                {/* Salon Name (Signature) */}
                <div style={{ textAlign: 'right' }}>
                  <div style={{
                    borderBottom: '2px solid #9ca3af',
                    paddingBottom: '4px',
                    marginBottom: '8px',
                    width: '256px',
                  }}>
                    <p style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#1f2937',
                      margin: 0,
                    }}>
                      {certificate?.salon_name}
                    </p>
                  </div>
                  <p style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    margin: 0,
                  }}>
                    Authorized By
                  </p>
                </div>
              </div>

              {/* Certificate Number */}
              <div style={{
                marginTop: '32px',
                fontSize: '11px',
                color: '#9ca3af',
              }}>
                <p style={{ margin: '0 0 4px 0' }}>
                  Certificate Number: {certificate?.certificate_number}
                </p>
                <p style={{ margin: 0 }}>
                  Issued: {certificate?.issued_at_formatted}
                </p>
              </div>
            </div>
          </div>

          {/* Footer Note */}
          <div className="print-hidden" style={{
            marginTop: '24px',
            textAlign: 'center',
            fontSize: '12px',
            color: '#9ca3af',
          }}>
            <p style={{ margin: 0 }}>
              This certificate can be printed or saved as PDF for your records.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingCertificate;